var _clipPath, _clipPath2, _clipPath3, _linearGradient, _clipPath4, _clipPath5, _clipPath6, _linearGradient2, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnnotouchcog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25.28125 19.706208",
    id: "svg1229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1223"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient48",
    spreadMethod: "pad",
    gradientTransform: "matrix(0,23.959999,-23.959999,0,42.108498,1.4160004)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop44-3",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop46-93",
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient66",
    spreadMethod: "pad",
    gradientTransform: "matrix(0,23.959999,-23.959999,0,42.108498,1.4160004)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop62-2",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop64-9",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient122",
    spreadMethod: "pad",
    gradientTransform: "matrix(-6.9319987,-37.229,37.229,-6.9319987,51.076389,82.212112)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop118-2",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop120-2",
    offset: 1,
    style: {
      stopOpacity: 0.39000534,
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient140",
    spreadMethod: "pad",
    gradientTransform: "matrix(-6.9319987,-37.229,37.229,-6.9319987,51.076389,82.212112)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop136",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop138",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18-8-5-6-2-7",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16-5-9-8-8-2",
    d: "M 0,66 H 85 V 0 H 0 Z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath34-1-4-5-4-7",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32-2-1-5-6-7",
    d: "M 2.44701,63.258 H 81.77 V 2.07201 H 2.44701 Z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath38-0-1-6-8-9",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36-0-7-7-9-6",
    d: "M 50.574,2.072 32.196,2.074 C 15.792,2.168 2.447,15.891 2.447,32.664 c 0,16.774 13.345,30.496 29.749,30.589 l 18.378,0.005 h 14.963 c 3.625,0 6.576,-3.014 6.576,-6.721 0.035,-3.298 0.105,-9.562 0.105,-9.754 0,-3.158 0.979,-4.505 3.279,-4.505 1.77,0 2.482,1.094 3,1.896 0.48,0.73 0.74,1.134 1.695,1.134 1.547,0 1.557,-5.079 1.568,-10.458 l 0.01,-2.284 c -0.006,-0.712 -0.006,-1.411 -0.008,-2.087 -0.014,-5.377 -0.023,-10.457 -1.57,-10.457 -0.955,0 -1.215,0.404 -1.695,1.135 -0.518,0.801 -1.23,1.895 -3,1.895 -2.301,0 -3.279,-1.348 -3.279,-4.508 0,-0.189 -0.07,-6.453 -0.105,-9.738 0,-3.717 -2.951,-6.732 -6.576,-6.732 H 50.574 Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50-0-4-0-2-8",
    height: 1,
    width: 1,
    y: 0,
    x: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g60-7-4-4-7-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g58-9-5-3-4-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g56-9-2-7-1-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g54-2-4-5-7-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path52-5-8-3-8-8",
    style: {
      fill: "url(#linearGradient48)",
      stroke: "none"
    },
    d: "M -32768,32767 H 32767 V -32768 H -32768 Z"
  })))))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient66",
    id: "linearGradient14383-6",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,23.959999,-23.959999,0,42.108498,1.4160004)",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    spreadMethod: "pad"
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath92-7-6-5-5-9",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path90-3-9-1-6-4",
    d: "M 2.44701,63.258 H 81.77 V 31.823 H 2.44701 Z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath108-8-8-4-0-1",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path106-6-7-9-3-6",
    d: "M 2.993,63.158 H 81.771 V 31.3123 H 2.993 Z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath112-2-2-5-9-0",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path110-0-6-0-7-7",
    d: "m 53.193,36.212 c 12.109,-0.183 22.918,-2.51 28.578,-3.531 -0.004,0.456 -0.008,1.542 -0.01,2.069 -0.012,5.379 -0.021,10.457 -1.568,10.457 -0.955,0 -1.215,-0.403 -1.695,-1.134 -0.518,-0.802 -1.23,-1.896 -3,-1.896 -2.301,0 -3.279,1.348 -3.279,4.505 0,0.192 -0.07,6.456 -0.105,9.755 0,3.706 -2.951,6.721 -6.576,6.721 H 50.574 c 0,0 -18.183,-0.004 -18.378,-0.006 C 17.727,63.071 5.645,52.385 2.993,38.355 c 7.453,-14.605 35.988,-1.93 50.2,-2.143"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask124-5-2-3-2-7",
    height: 1,
    width: 1,
    y: 0,
    x: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g134-4-2-1-7-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g132-1-0-0-1-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g130-6-6-6-0-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g128-1-6-4-0-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path126-9-5-8-9-8",
    style: {
      fill: "url(#linearGradient122)",
      stroke: "none"
    },
    d: "M -32768,32767 H 32767 V -32768 H -32768 Z"
  })))))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient140",
    id: "linearGradient14385-2",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-6.9319987,-37.229,37.229,-6.9319987,51.076389,82.212112)",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    spreadMethod: "pad"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-71.139639,-327.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g21731",
    transform: "translate(-326.8455,17.610463)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.003158,-120.46229)",
    id: "g16777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12-2-0-3-4-1",
    transform: "matrix(0.30240009,0,0,-0.30240009,382.93002,450.25469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14-4-0-9-1-0",
    clipPath: "url(#clipPath18-8-5-6-2-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20-6-7-7-6-5",
    transform: "translate(32.185,0.582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -17.209,0.095 -31.21,14.487 -31.21,32.082 0,17.594 14.001,31.987 31.21,32.084 l 4.439,-0.008 h 29.256 c 4.433,0 8.039,-3.684 8.039,-8.213 0,0 0.107,-9.543 0.107,-9.749 0,-3.011 0.92,-3.011 1.809,-3.011 0.977,0 1.311,0.513 1.772,1.223 0.523,0.804 1.175,1.804 2.921,1.804 3.012,0 3.023,-4.76 3.04,-11.966 l 0.007,-2.264 -0.006,-2.064 c -0.017,-7.207 -0.028,-11.969 -3.04,-11.969 -1.746,0 -2.397,1.002 -2.921,1.807 -0.462,0.711 -0.796,1.225 -1.772,1.225 -0.889,0 -1.809,0 -1.809,-3.014 0,-0.207 -0.107,-9.752 -0.107,-9.752 0,-4.523 -3.606,-8.209 -8.039,-8.209 L 4.439,0.006 0.004,0 C 0.004,0 0,0 0,0",
    style: {
      fill: "#ffea00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22-5-6-6-1-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g24-8-9-4-3-7",
    transform: "translate(32.19,65.248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -0.008 c -17.483,-0.099 -31.707,-14.716 -31.707,-32.584 0,-17.869 14.224,-32.485 31.708,-32.582 l 4.442,0.006 h 29.256 c 4.708,0 8.539,3.909 8.539,8.715 0.004,0.379 0.107,9.536 0.107,9.746 0,2.514 0.549,2.514 1.309,2.514 0.671,0 0.872,-0.256 1.354,-0.997 0.526,-0.811 1.322,-2.034 3.34,-2.034 3.511,0 3.522,4.96 3.54,12.467 10e-4,0.667 0.003,1.354 0.007,2.061 v 0.205 c -0.004,0.711 -0.006,1.399 -0.007,2.066 -0.018,7.506 -0.029,12.465 -3.54,12.465 -2.017,0 -2.812,-1.222 -3.34,-2.031 -0.481,-0.74 -0.683,-0.996 -1.354,-0.996 -0.76,0 -1.309,0 -1.309,2.511 0,0.209 -0.104,9.371 -0.107,9.76 0,4.793 -3.831,8.702 -8.539,8.702 H 4.434 Z m -0.002,-1 4.436,-0.008 h 29.257 c 4.164,0 7.539,-3.455 7.539,-7.713 0,0 0.107,-9.543 0.107,-9.749 0,-3.113 0.975,-3.511 2.309,-3.511 2.566,0 1.824,3.027 4.693,3.027 2.76,0 2.502,-5.619 2.547,-13.531 v -0.2 c -0.045,-7.91 0.213,-13.533 -2.547,-13.533 -2.869,0 -2.127,3.031 -4.693,3.031 -1.334,0 -2.309,-0.4 -2.309,-3.514 0,-0.207 -0.107,-9.746 -0.107,-9.746 0,-4.262 -3.375,-7.715 -7.539,-7.715 H 4.434 l -4.436,-0.006 c -16.978,0.096 -30.713,14.199 -30.713,31.584 0,17.387 13.735,31.488 30.713,31.584",
    style: {
      fill: "#d6bd05",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26-5-7-8-7-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28-7-6-4-7-7"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g30-3-6-7-4-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g84-3-8-4-6-3"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath34-1-4-5-4-7)",
    id: "g82-2-4-3-7-2",
    style: {
      opacity: 0.330002
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g80-5-3-6-1-6"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath38-0-1-6-8-9)",
    id: "g78-3-0-2-5-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g76-9-6-9-9-1"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g68-1-8-3-8-7"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50-0-4-0-2-8)",
    id: "g74-9-5-6-0-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g72-5-9-9-3-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 50.574,2.072 32.196,2.074 C 15.792,2.168 2.447,15.891 2.447,32.664 c 0,16.774 13.345,30.496 29.749,30.589 l 18.378,0.005 h 14.963 c 3.625,0 6.576,-3.014 6.576,-6.721 0.035,-3.298 0.105,-9.562 0.105,-9.754 0,-3.158 0.979,-4.505 3.279,-4.505 1.77,0 2.482,1.094 3,1.896 0.48,0.73 0.74,1.134 1.695,1.134 1.547,0 1.557,-5.079 1.568,-10.458 l 0.01,-2.284 c -0.006,-0.712 -0.006,-1.411 -0.008,-2.087 -0.014,-5.377 -0.023,-10.457 -1.57,-10.457 -0.955,0 -1.215,0.404 -1.695,1.135 -0.518,0.801 -1.23,1.895 -3,1.895 -2.301,0 -3.279,-1.348 -3.279,-4.508 0,-0.189 -0.07,-6.453 -0.105,-9.738 0,-3.717 -2.951,-6.732 -6.576,-6.732 H 50.574 Z",
    style: {
      fill: "url(#linearGradient14383-6)",
      stroke: "none"
    },
    id: "path70-4-1-4-0-7"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "g86-8-4-1-3-3"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g88-0-0-8-1-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g100-0-5-1-5-3"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath92-7-6-5-5-9)",
    id: "g98-4-3-6-3-7",
    style: {
      opacity: 0.649994
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.196,61.851)",
    id: "g96-7-9-7-0-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 18.378,0.005 h 14.963 c 3.625,0 6.576,-3.016 6.576,-6.723 0.035,-3.297 0.105,-9.562 0.105,-9.752 0,-3.158 0.979,-4.505 3.279,-4.505 1.77,0 2.482,1.094 3,1.896 0.48,0.73 0.74,1.133 1.695,1.133 1.547,0 1.557,-5.08 1.568,-10.457 l 0.006,-1.625 0.004,0.743 -0.01,2.284 c -0.012,5.379 -0.021,10.458 -1.568,10.458 -0.955,0 -1.215,-0.403 -1.695,-1.134 -0.518,-0.802 -1.23,-1.896 -3,-1.896 -2.301,0 -3.279,1.347 -3.279,4.505 0,0.191 -0.07,6.456 -0.105,9.754 0,3.707 -2.951,6.721 -6.576,6.721 H 18.378 L 0,1.402 c -16.404,-0.093 -29.749,-13.815 -29.749,-30.589 0,-0.236 0.011,-0.467 0.017,-0.701 C -29.365,-13.437 -16.175,-0.093 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94-2-1-9-8-3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g102-3-8-0-3-5"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g104-1-3-2-8-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g158-5-3-3-6-0"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath108-8-8-4-0-1)",
    id: "g156-0-5-7-3-2",
    style: {
      opacity: 0.600006
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g154-5-2-8-8-0"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath112-2-2-5-9-0)",
    id: "g152-8-5-4-4-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g150-7-5-1-5-6"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g142-3-4-8-9-2"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask124-5-2-3-2-7)",
    id: "g148-7-5-5-0-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g146-1-8-9-2-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 53.193,36.212 c 12.109,-0.183 22.918,-2.51 28.578,-3.531 -0.004,0.456 -0.008,1.542 -0.01,2.069 -0.012,5.379 -0.021,10.457 -1.568,10.457 -0.955,0 -1.215,-0.403 -1.695,-1.134 -0.518,-0.802 -1.23,-1.896 -3,-1.896 -2.301,0 -3.279,1.348 -3.279,4.505 0,0.192 -0.07,6.456 -0.105,9.755 0,3.706 -2.951,6.721 -6.576,6.721 H 50.574 c 0,0 -18.183,-0.004 -18.378,-0.006 C 17.727,63.071 5.645,52.385 2.993,38.355 c 7.453,-14.605 35.988,-1.93 50.2,-2.143",
    style: {
      fill: "url(#linearGradient14385-2)",
      stroke: "none"
    },
    id: "path144-6-1-6-1-0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "g15863",
    transform: "translate(-23.790958,1.4763574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 416.65293,432.64783 -0.001,1.7e-4 c 6.1e-4,0 0.001,-1.7e-4 0.001,-1.7e-4 m -3.58614,6.71843 3.58631,2.07165 3.5863,-2.07165 v -4.13862 l -1.5263,-0.84679 h -4.17882 l -1.46749,0.84665 z m 3.58476,3.51219 c -0.19166,0 -0.38437,-0.0512 -0.55717,-0.14766 l -3.8642,-2.23293 c -0.34505,-0.19607 -0.56064,-0.5688 -0.56064,-0.97181 v -4.45831 c 0,-0.39849 0.21465,-0.77061 0.5602,-0.97121 l 3.86089,-2.231 c 0.3552,-0.19905 0.77138,-0.19679 1.11826,-0.002 l 3.86767,2.23293 c 0.34555,0.2006 0.56004,0.57272 0.56004,0.97121 v 4.45831 c 0,0.40301 -0.21543,0.77574 -0.56247,0.97275 l -3.86193,2.2299 c -0.17606,0.0986 -0.36882,0.14975 -0.56065,0.14975",
    style: {
      fill: "#898345",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0551382
    },
    id: "path22-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 420.5476,439.39314 c 0,0.096 -0.0527,0.18278 -0.13321,0.22926 l -3.6281,2.09752 c -0.0806,0.0465 -0.18587,0.0465 -0.26643,0 l -3.62809,-2.09752 c -0.0806,-0.0465 -0.13322,-0.13321 -0.13322,-0.22926 v -4.19194 c 0,-0.093 0.0527,-0.18278 0.13322,-0.22926 l 1.65064,-0.95675 4.15067,-0.008 1.72131,0.96456 c 0.0805,0.0465 0.13321,0.1363 0.13321,0.22926 z m -3.89452,-7.05477 c 0.17352,0 0.31291,0.14253 0.31291,0.31296 0,0.10532 -0.0496,0.19828 -0.13322,0.25402 -0.0496,0.0372 -0.11463,0.0589 -0.17969,0.0589 -0.0712,0 -0.13322,-0.0217 -0.1797,-0.0589 -0.0836,-0.0557 -0.13321,-0.1487 -0.13321,-0.25402 0,-0.17043 0.14253,-0.31296 0.31291,-0.31296 m 4.26632,2.02627 -1.62967,-0.94187 -0.25099,-0.14562 -1.97979,-1.14323 c -0.13013,-0.0712 -0.26643,-0.10846 -0.40587,-0.10846 -0.13945,0 -0.27884,0.0372 -0.40588,0.10846 l -1.9767,1.14323 -0.25094,0.14562 -1.63281,0.94187 c -0.25093,0.14562 -0.40587,0.41519 -0.40587,0.70335 v 4.45836 c 0,0.29124 0.15494,0.56082 0.40587,0.70335 l 3.86045,2.23073 c 0.12704,0.0712 0.26643,0.10845 0.40588,0.10845 0.13944,0 0.27574,-0.0372 0.40587,-0.10845 l 3.86045,-2.23073 c 0.25093,-0.14253 0.40587,-0.41211 0.40587,-0.70335 v -4.45836 c 0,-0.28816 -0.15494,-0.55773 -0.40587,-0.70335",
    style: {
      fill: "#34332b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0551382
    },
    id: "path26-57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 416.65308,436.67929 c -0.34053,0 -0.61766,0.27712 -0.61766,0.61766 0,0.34059 0.27713,0.61771 0.61766,0.61771 0.3407,0 0.61766,-0.27712 0.61766,-0.61771 0,-0.34054 -0.27696,-0.61766 -0.61766,-0.61766 m 0,1.81008 c -0.65752,0 -1.19242,-0.5349 -1.19242,-1.19242 0,-0.65752 0.5349,-1.19242 1.19242,-1.19242 0.65752,0 1.19242,0.5349 1.19242,1.19242 0,0.65752 -0.5349,1.19242 -1.19242,1.19242",
    style: {
      fill: "#898345",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0551382
    },
    id: "path34-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 417.55813,437.29696 c 0,0.49983 -0.40521,0.90504 -0.90504,0.90504 -0.49988,0 -0.90504,-0.40521 -0.90504,-0.90504 0,-0.49983 0.40516,-0.90504 0.90504,-0.90504 0.49983,0 0.90504,0.40521 0.90504,0.90504",
    style: {
      fill: "#34332b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0551382
    },
    id: "path38-2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 416.2157,328.63164 c -0.31952,-0.12468 -0.57258,-0.18846 -0.89977,-0.32473 -0.24028,-0.10146 -0.48823,-0.23486 -0.7234,-0.28994 -0.22749,-0.0522 -0.48822,-0.22906 -0.79496,-0.41752 -0.23006,-0.14208 -0.47033,-0.29574 -0.70294,-0.40011 -0.41666,-0.18558 -0.60326,-0.5625 -0.76941,-0.89013 -0.11758,-0.23486 -0.23006,-0.45522 -0.41409,-0.62338 0,0 -0.10487,-0.0666 -0.11759,-0.10728 -0.0127,-0.0464 0.046,-0.18557 0.046,-0.18557 0.0638,-0.20584 0.38854,-0.43491 0.73106,-0.43491 0.1278,0 0.25306,0.0319 0.37064,0.0928 0.0741,0.0377 0.15081,0.10436 0.24539,0.19137 0.1457,0.13047 0.34253,0.30444 0.51634,0.33923 -0.76429,-0.81763 -2.33889,-2.51379 -2.91913,-3.27344 -0.31696,-0.41753 -0.49334,-1.0467 -0.1278,-1.44392 0.10227,-0.11307 0.24027,-0.17686 0.38342,-0.17397 0.31441,0 0.63393,0.28126 0.84864,0.49291 0.16616,0.16526 0.33231,0.32764 0.49845,0.4929 0.46779,0.46101 0.99947,0.98001 1.43145,1.43811 0.0716,-0.0841 0.29397,-0.33343 0.61605,-0.61758 0.1508,-0.13336 0.33484,-0.16235 0.46265,-0.16235 0.11759,0 0.26073,0.026 0.38342,0.087 0.19684,-0.19425 0.44733,-0.43201 0.52402,-0.4784 0.13293,-0.0783 0.27862,-0.11888 0.42944,-0.11598 0.2505,0 0.49334,0.11019 0.67994,0.30444 0.15592,-0.0493 0.42431,-0.12468 0.63392,-0.12468 0.34509,0 0.61604,0.39433 0.8333,0.77705 0.78987,1.39173 0.95601,1.91652 0.78475,3.30535 -0.16103,1.29024 -0.61859,2.54568 -2.91657,2.54858 -0.0102,0 -0.023,-0.003 -0.0333,-0.006 z",
    style: {
      fill: "#34332b",
      strokeWidth: 0.272239
    },
    id: "path13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnnotouchcog);
export default __webpack_public_path__ + "static/media/onnotouchcog.3aff3a3ba8dbda7ead66d98ba3bcd2ee.svg";
export { ForwardRef as ReactComponent };